<template>
  <ins class="adsbygoogle"
       :data-ad-client="adClient"
       :data-ad-slot="adSlot"
       :data-ad-format="adFormat"
       :data-ad-layout-key="adLayoutKey"
       :style="adStyle"
  ></ins>
</template>

<script>
export default {
  props: {
    adClient: {
      type: String,
      required: true
    },
    adSlot: {
      type: String,
      required: true
    },
    adFormat: {
      type: String,
      required: false,
      default: 'auto'
    },
    adStyle: {
      type: String,
      required: false,
      default: 'display: block'
    },
    adLayoutKey: {
      type: String,
      required: false,
      default: ''
    }
  },
  mounted () {
    (window.adsbygoogle = window.adsbygoogle || []).push({})
  }
}
</script>



// WEBPACK FOOTER //
// adsense.vue?3e22f6a4